"use client"

import { useEffect, useRef } from "react"
import { useAnimatedThemeToggle } from "@/lib/use-animated-theme-toggle"

function isThemeShortcutBlockedTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) {
        return false
    }
    const tag = target.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") {
        return true
    }
    if (target.isContentEditable) {
        return true
    }
    if (target.closest("[contenteditable='true']")) {
        return true
    }
    if (target.getAttribute("role") === "textbox") {
        return true
    }
    return false
}

export function ThemeKeyboardShortcut() {
    const originRef = useRef<HTMLElement>(null)
    const { toggleTheme } = useAnimatedThemeToggle(originRef, {
        sound: true,
    })

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key.toLowerCase() !== "d") {
                return
            }
            if (e.metaKey || e.ctrlKey || e.altKey) {
                return
            }
            if (isThemeShortcutBlockedTarget(e.target)) {
                return
            }
            e.preventDefault()
            void toggleTheme()
        }

        document.addEventListener("keydown", onKeyDown)
        return () => document.removeEventListener("keydown", onKeyDown)
    }, [toggleTheme])

    return null
}
